export function shouldRetainCachedResponse(isOnline: boolean, data: unknown) {
  return !isOnline && data !== undefined;
}

export type CachedResponse<T> = {
  $cacheVersion: 2;
  $data: T;
  $cachedAt: number;
  $cacheMaxAge: number;
  $collection?: string;
  $isStale?: boolean;
};

export function createCachedResponse<T>(data: T, cacheMaxAge: number): CachedResponse<T> {
  return {
    $cacheVersion: 2,
    $data: data,
    $cachedAt: Date.now(),
    $cacheMaxAge: cacheMaxAge,
  };
}

export function isCachedResponse<T>(value: unknown): value is CachedResponse<T> {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<CachedResponse<T>>;
  return candidate.$cacheVersion === 2 && '$data' in candidate && typeof candidate.$cachedAt === 'number' && typeof candidate.$cacheMaxAge === 'number';
}
